import { createSlice } from "@reduxjs/toolkit";
import {
  getVoucherReport,
  getVoucherApprovalReport,
  getVoucherAuthenticateReport,
  getVoucherByApproval,
  updateVoucherByApproval,
  getVoucherByAuthenticate,
  updateVoucherByAuthenticate,
} from "./actions/voucherAction.js";

const initialState = {
  loading: false,
  voucherUsers: null,
  voucherActivity: null,

  voucherDetail: null,

  voucherReport: null,
  totalByVoucherReport: 0,
  voucherReportFilters: {},
  voucherReportPageState: { page: 1, pageSize: 50 },

  voucherApprovalReport: null,
  totalByVoucherApprovalReport: 0,
  voucherApprovalReportFilters: {},
  voucherApprovalReportPageState: { page: 1, pageSize: 50 },

  voucherAuthenticateReport: null,
  totalByVoucherAuthenticateReport: 0,
  voucherAuthenticateReportFilters: {},
  voucherAuthenticateReportPageState: { page: 1, pageSize: 50 },

  voucherByApproval: null,
  totalByVoucherApproval: 0,
  voucherApprovalFilters: {},
  voucherApprovalPageState: { page: 1, pageSize: 50 },

  voucherByAuthenticate: null,
  totalByVoucherAuthenticate: 0,
  voucherAuthenticateFilters: {},
  voucherAuthenticatePageState: { page: 1, pageSize: 50 },
};

export const voucherSlice = createSlice({
  name: "voucher",
  initialState,
  reducers: {
    setVoucherActivity: (state, action) => {
      state.voucherActivity = action.payload;
    },
    setVoucherActivityNull: (state) => {
      state.voucherActivity = null;
    },

    setVoucherByApprovalDetail: (state, action) => {
      const voucher = state.voucherByApproval.find(
        (_voucher) => _voucher.id === action.payload
      );
      state.voucherDetail = voucher;
    },

    setVoucherByAuthenticateDetail: (state, action) => {
      const voucher = state.voucherByAuthenticate.find(
        (_voucher) => _voucher.id === action.payload
      );
      state.voucherDetail = voucher;
    },

    setVoucherReportDetail: (state, action) => {
      const voucher = state.voucherReport.find(
        (_voucher) => _voucher.id === action.payload
      );
      state.voucherDetail = voucher;
    },

    setVoucherByApprovalReportDetail: (state, action) => {
      const voucher = state.voucherApprovalReport.find(
        (_voucher) => _voucher.id === action.payload
      );
      state.voucherDetail = voucher;
    },

    setVoucherByAuthenticateReportDetail: (state, action) => {
      const voucher = state.voucherAuthenticateReport.find(
        (_voucher) => _voucher.id === action.payload
      );
      state.voucherDetail = voucher;
    },

    setVoucherReportFilters: (state, action) => {
      const { payload } = action;
      state.voucherReportFilters = payload || {};
    },
    resetVoucherReportFilters: (state) => {
      state.voucherReportFilters = {};
    },
    setVoucherReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.voucherReportPageState = {
          ...state.voucherReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.voucherReportPageState = {
          ...state.voucherReportPageState,
          pageSize,
        };
      }
    },

    setVoucherApprovalReportFilters: (state, action) => {
      const { payload } = action;
      state.voucherApprovalReportFilters = payload || {};
    },
    resetVoucherApprovalReportFilters: (state) => {
      state.voucherApprovalReportFilters = {};
    },
    setVoucherApprovalReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.voucherApprovalReportPageState = {
          ...state.voucherApprovalReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.voucherApprovalReportPageState = {
          ...state.voucherApprovalReportPageState,
          pageSize,
        };
      }
    },

    setVoucherAuthenticateReportFilters: (state, action) => {
      const { payload } = action;
      state.voucherAuthenticateReportFilters = payload || {};
    },
    resetVoucherAuthenticateReportFilters: (state) => {
      state.voucherAuthenticateReportFilters = {};
    },
    setVoucherAuthenticateReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.voucherAuthenticateReportPageState = {
          ...state.voucherAuthenticateReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.voucherAuthenticateReportPageState = {
          ...state.voucherAuthenticateReportPageState,
          pageSize,
        };
      }
    },

    setVoucherApprovalFilters: (state, action) => {
      const { payload } = action;
      state.voucherApprovalFilters = payload || {};
    },
    resetVoucherApprovalFilters: (state) => {
      state.voucherApprovalFilters = {};
    },
    setVoucherApprovalPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.voucherApprovalPageState = {
          ...state.voucherApprovalPageState,
          page,
        };
      }
      if (pageSize) {
        state.voucherApprovalPageState = {
          ...state.voucherApprovalPageState,
          pageSize,
        };
      }
    },

    setVoucherAuthenticateFilters: (state, action) => {
      const { payload } = action;
      state.voucherAuthenticateFilters = payload || {};
    },
    resetVoucherAuthenticateFilters: (state) => {
      state.voucherAuthenticateFilters = {};
    },
    setVoucherAuthenticatePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.voucherAuthenticatePageState = {
          ...state.voucherAuthenticatePageState,
          page,
        };
      }
      if (pageSize) {
        state.voucherAuthenticatePageState = {
          ...state.voucherAuthenticatePageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVoucherReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoucherReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherReport = data;
        state.totalByVoucherReport = count;
        state.voucherUsers = user;
      })
      .addCase(getVoucherReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVoucherApprovalReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoucherApprovalReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherApprovalReport = data;
        state.totalByVoucherApprovalReport = count;
        state.voucherUsers = user;
      })
      .addCase(getVoucherApprovalReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVoucherAuthenticateReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoucherAuthenticateReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherAuthenticateReport = data;
        state.totalByVoucherAuthenticateReport = count;
        state.voucherUsers = user;
      })
      .addCase(getVoucherAuthenticateReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVoucherByApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoucherByApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherByApproval = data;
        state.voucherUsers = user;
        state.totalByVoucherApproval = count;
      })
      .addCase(getVoucherByApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateVoucherByApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVoucherByApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherByApproval = data;
        state.voucherUsers = user;
        state.totalByVoucherApproval = count;
      })
      .addCase(updateVoucherByApproval.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVoucherByAuthenticate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVoucherByAuthenticate.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherByAuthenticate = data;
        state.voucherUsers = user;
        state.totalByVoucherAuthenticate = count;
      })
      .addCase(getVoucherByAuthenticate.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateVoucherByAuthenticate.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVoucherByAuthenticate.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.voucherByAuthenticate = data;
        state.voucherUsers = user;
        state.totalByVoucherAuthenticate = count;
      })
      .addCase(updateVoucherByAuthenticate.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setVoucherActivity,
  setVoucherActivityNull,

  setVoucherByApprovalDetail,
  setVoucherByAuthenticateDetail,
  
  setVoucherReportDetail,
  setVoucherByApprovalReportDetail,
  setVoucherByAuthenticateReportDetail,

  resetVoucherReportFilters,
  setVoucherReportFilters,
  setVoucherReportPage,

  resetVoucherApprovalReportFilters,
  setVoucherApprovalReportFilters,
  setVoucherApprovalReportPage,

  resetVoucherAuthenticateReportFilters,
  setVoucherAuthenticateReportFilters,
  setVoucherAuthenticateReportPage,

  resetVoucherApprovalFilters,
  setVoucherApprovalFilters,
  setVoucherApprovalPage,

  setVoucherAuthenticateFilters,
  resetVoucherAuthenticateFilters,
  setVoucherAuthenticatePage,
} = voucherSlice.actions;

export default voucherSlice.reducer;
